import Skeleton from "../../common/Skeleton";

const PatternInsightSkeleton = () => {
  return (
    <div className="lg:col-span-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-1 lg:gap-1 h-full">
      {[...Array(4)].map((_, index) => (
        <div key={index} className="col-span-12 lg:col-span-6">
          <Skeleton className="w-full h-[300px] rounded-2xl" />
        </div>
      ))}
    </div>
  );
};

export default PatternInsightSkeleton;
